import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const ProductItem = ({ index, category, product, type }) => {
  const [openLightbox, setOpenLightbox] = useState(false);

  const itemVariants = {
    hidden: { opacity: 0, y: 30, scale: 1.1 },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.5, ease: "easeInOut" },
    },
    hover: {
      scale: 1.05,
      boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.15)",
      transition: { duration: 0.5, ease: "easeInOut" },
    },
  };

  const handleImageClick = () => {
    setOpenLightbox(true);
  };

  return (
    <>
      <motion.div
        custom={index}
        key={index}
        className="text-black  bg-white"
        variants={itemVariants}
      >
        <div className="!overflow-hidden h-full group shadow-sm hover:shadow transition-all duration-300 hover:scale-105 bg-white">
          <Link
            to={type === "home" && `/urunler/${category.categoryUrl}`}
            className={`cursor-auto h-full flex flex-col justify-between ${
              type === "home" ? "cursor-pointer" : "cursor-auto"
            }`}
          >
            <div className="aspect-square w-full bg-white !overflow-hidden">
              {type === "product" && (
                <img
                  src={`/images/products/${category.categoryUrl}/${product.productUrl}/0.png`}
                  className="aspect-square h-full w-full object-cover cursor-pointer group-hover:scale-105 transition-all duration-300"
                  onClick={!product.productImageData && handleImageClick}
                  alt=""
                />
              )}
              {type === "home" && (
                <img
                  src={`/images/products/${category.categoryUrl}/main.jpg`}
                  className="aspect-square h-full w-full object-cover group-hover:scale-105 transition-all duration-300"
                  onClick={!product.productImageData &&handleImageClick}
                  alt=""
                />
              )}
            </div>

            <div className="px-5 pb-5 flex flex-col justify-between flex-1 space-y-5 ">
              <div>
                {/* <div className="pt-5">
                  {type === "product" && (
                    <h6 className="font-medium text-2xl group-hover:text-turkuaz-blue transition-all duration-300">
                      {product.productName}
                    </h6>
                  )}
                  {type === "home" && (
                    <h6 className="font-medium text-2xl text-turkuaz-blue">
                      {category.categoryName}
                    </h6>
                  )}
                </div> */}

              </div>
              {/* {type === "home" && (
                <div className="flex space-x-2">
                  <h2 className="text-xs">DAHA FAZLASI İÇİN</h2>
                  <img
                    src="/images/right-hook.svg"
                    alt="Arrow icon"
                    className="group-hover:translate-x-2 transition-all duration-300"
                  />
                </div>
              )} */}

              {type === "product" && (
                <div className={`h-8 w-full flex justify-end items-end`}>
                  <div className="h-7 w-7 relative flex justify-center items-center group-hover:rotate-45 transition-all duration-300">
                    <div className="absolute h-0.5 w-7 bg-[#B0B0B0]"></div>
                    <div className="absolute h-0.5 w-7 bg-[#B0B0B0] rotate-90"></div>
                  </div>
                </div>
              )}



              
            </div>
          </Link>
        </div>
      </motion.div>

      {type === "product" && openLightbox && (
        <Lightbox
          open={openLightbox}
          close={() => setOpenLightbox(false)}
          slides={[
            {
              src: `/images/products/${category.categoryUrl}/${product.productUrl}/0.png`,
            },
          ]}
          className="custom-lightbox"
        />
      )}





    </>
  );
};

export default ProductItem;
